import type { StorePermitPayload } from '@extJurAutofill/externalPackagesContract/StorePermitPayload';
import { buildPermitToPrefill } from '@extJurAutofill/shared/buildPermitToPrefill';
import type { PermitSummary } from '@src/orders/domain/PermitSummary';

export const buildStorePermitPayload = ({
  permit,
  language,
}: {
  permit: PermitSummary;
  language: string;
}): StorePermitPayload => ({
  language,
  permitToPrefill: buildPermitToPrefill({
    permitId: permit.id,
    targetUrl: permit.jurisdictionUrl!,
    permitType: permit.type,
    fields: permit.fields,
    unitSystem: permit.unit,
    entries: permit.entries,
    effectiveDate: permit.effectiveDate.format(),
  }),
});
